<template>
  <div style=" width: 100%; height: 100%">
    <Nav current="我的公司"></Nav>
    <div class="content-all">
      <div style="text-indent:1em;">批量修改角色</div>
      <div class="transfer">
        <div class="row-wigth row">
          <el-row class="title">
            <span style="color: red">提示: &nbsp;&nbsp;</span>
            在左侧勾选用户后，移到右侧，在右侧进行批量修改角色。</el-row>
          <el-row class="title">编号</el-row>
          <el-col class="row-wigth col-l flex" :span="10">
            <el-input
              class="sacheripu"
              type="text"
              v-model="userName"
              placeholder="查找手机号码/用户名"
            /><span class="el-icon-search search" @click="getNumberList"></span>
            <el-table
              :data="table1Data"
              ref="table1"
              max-height="420"
              @selection-change="onTable1Select"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="name" label="编号" width="155">
              </el-table-column>
              <el-table-column prop="mobile" label="手机号码" width="166">
              </el-table-column>
              <el-table-column prop="userName" label="用户名" width="93">
              </el-table-column>
              <el-table-column prop="roleName" label="角色" width="73">
              </el-table-column>
            </el-table>
          </el-col>
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next, total"
              :total="total"
              :current-page="currentPage"
              :page-size="pageSize"
              :page-sizes="[10, 30, 50, 70, 100]"
              @size-change="changePageSize"
              @current-change="changeCurrentSize"
            >
            </el-pagination>
            <!-- <span>共{{ total }}条</span> -->
          </div>
        </div>

        <div class="tap">
          <el-col class="col" :span="4">
            <el-button class="tap-btn el-icon-arrow-right"  type="primary" @click="onAdd"
              ></el-button
            ><br />
            <el-button class="tap-btn el-icon-arrow-left" type="primary" @click="onDelete"
              ></el-button
            >
          </el-col>
        </div>

        <div class="row-wigth">
          <el-row class="title">
            角色：
            <select :class="!roleId && emptyRoleWarn ? 'select blink': 'select'" v-model="roleId" @change="setRoleId()">
              <option v-for="item in roleList" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </el-row>
          <el-row class="title"
            >共  ( <span class="font-color">{{ totalNum }}</span> )  条,已选择   (<span class="font-color" >{{ chakedNum }}</span>)   条</el-row
          >
          <el-col class="row-wigth col-l" :span="10">
            <el-table
              :data="table2Data"
              ref="table2"
              max-height="420"
              @selection-change="onTable2Select"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="name" label="编号" width="155">
              </el-table-column>
              <el-table-column prop="mobile" label="手机号码" width="166">
              </el-table-column>
              <el-table-column prop="userName" label="用户名" width="93">
              </el-table-column>
              <el-table-column prop="roleName" label="角色" width="73">
              </el-table-column>
            </el-table>
          </el-col>
        </div>
      </div>
    </div>
    <div class="bottom-btn">
      <el-row class="el-row">
      <el-button type="primary" class="el-button btnSty" @click="updateNumber">保存</el-button>
      <el-button class="el-button btnret" @click="retSuper">返回</el-button>
    </el-row>
    </div>
  </div>
  
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      table1Data: [],
      table2Data: [],
      selectedTable1Data: [], // table1已选数据
      selectedTable2Data: [], // table2已选数据
      currentPage: 1,
      pageSize: 10,
      total: 0,
      roelName: "",
      roleList: [],
      totalNum: "0",
      chakedNum: "0",
      userName: "",
      roleId: '',
      emptyRoleWarn: false,//右侧未选择角色警告展示
    };
  },
  created() {},
  mounted() {
    this.getNumberList();
    this.getRoleList();
  },
  methods: {
    getNumberList() {
      let _this = this;
      let  params = { 
          name: _this.userName,
          pageNum: _this.currentPage,
          pageSize: _this.pageSize,
        }
      http.get(apiData.numberList, true, params, (res) => {
        if (res.data.code == 200) {
          //   _this.$message.success("加载成功");
          _this.table1Data = res.data.data.list;
          _this.total = res.data.data.totalRow;
        }
      });
    },
    getRoleList() {
      let _this = this;
      http.get(apiData.showRoleList, true, {}, (res) => {
        // console.log(res.data.data);
        _this.roleList = res.data.data;
      });
    },
    setRoleId() {
      let _this = this;
      console.log(_this.roleId)
    },
    updateNumber() {
      let _this = this;
      let roleIdList = []
      let updateRoleIdList = []
      for (let i = 0; i < _this.table2Data.length; i++) {
        // console.log(_this.table2Data[i].id)
        roleIdList.push(_this.table2Data[i].id);
        // updateRoleIdList = roleIdList.join(',')
        updateRoleIdList = roleIdList.toString()
        // console.log(updateRoleIdList)
      }
      // esther HB357 20251030 批量修改角色时，从右侧往左侧输入时，提示语言报错
      if (!_this.roleId) {
        _this.emptyRoleWarn = true
        _this.$message.error("请为右侧列表中的用户选择新角色。");
        return
      } else {
        _this.emptyRoleWarn = false
      }
      if (updateRoleIdList?.length) {
        let params = {
          ids:updateRoleIdList,
          roleId:_this.roleId
        };
        http.put(apiData.batchNumber, true, params, (res) => {
          if (res.data.code == 200) {
              _this.$message.success("批量修改成功");
              _this.$router.go(-1)
            } else {
              _this.$message.error("批量修改失败");
            }
        });
      } else {
        _this.$message.error("请从左侧选择用户并移至右侧，在右侧为其批量选择新角色。");
      }
      
    },
    /**
     * table1选择事件处理函数
     * @param {array} rows 已勾选的数据
     */
    onTable1Select(rows) {
      this.selectedTable1Data = [...rows];
      // console.log(this.selectedTable1Data);
    },

    /**
     * table2选择事件处理函数
     * @param {array} rows 已勾选的数据
     */
    onTable2Select(rows) {
      this.selectedTable2Data = [...rows];
      this.chakedNum = this.selectedTable2Data.length;
    },

    /**
     * 添加按钮事件处理函数
     */
    onAdd() {
      this.filterAdd(this.selectedTable1Data, this.table2Data, "id");
      // let aa = this.$refs.table1.clearSelection();
      this.totalNum = this.table2Data.length;
      // 循环遍历当前选中数据的数组
      for (let i = 0; i < this.selectedTable1Data.length; i++) {
        //
        let stable = this.selectedTable1Data[i];
        let removeindex = -1;
        // 循环
        for (let j = 0; j < this.table1Data.length; j++) {
          let tabalData1 = this.table1Data[j];
          if (tabalData1.id == stable.id) {
            removeindex = j;
            // this.table1Data[j].splice
            // console.log('删除', this.table1Data[j].splice(1) )            
            break;
          }
        }
        if(removeindex>-1){
      this.table1Data.splice(removeindex,1);
        }

      }
      console.log(this.table2Data)
      this.selectedTable1Data = [];
    },

    /**
     * 删除按钮事件处理函数
     */
    onDelete() {
      this.table2Data = this.filterDelete(this.selectedTable2Data,this.table2Data,"id");
      
        // 循环遍历当前选中数据的数组
      for (let i = 0; i < this.selectedTable2Data.length; i++) {       
        let removeindex = -1;
        let stable = this.selectedTable2Data[i];
        // 循环
        for (let j = 0; j < this.table2Data.length; j++) {
          let tabalData2 = this.table2Data[j];
          if (tabalData2.id == stable.id) {
            removeindex = j;
            break;
          }
        }
        console.log(stable)
        this.table1Data.push(stable)
        if(removeindex>-1){
          
      this.table2Data.splice(removeindex,1);
        }

      }
     this.selectedTable2Data = []; 
           this.totalNum = this.table2Data.length;

    },

    /**
     * 根据选中项去重添加到array中
     * @param {array} records   待添加数据
     * @param {array} targetRecords   目标数据
     * @param {string} compareProperty  对比的重复属性
     * @param {boolean} isEnd   往尾部添加？默认往头部添加
     */
    filterAdd(
      records = [],
      targetRecords = [],
      compareProperty,
      isEnd = false
    ) {
      const o = new Set();
      //循环遍历目标数据
      targetRecords.forEach((record) => {
        o.add(record[compareProperty]);
      });
      records.forEach((record) => {
        if (!o.has(record[compareProperty])) {
          if (isEnd) {
            targetRecords.push(record);
          } else {
            targetRecords.unshift(record);
          }
        }
      });
    },

    /**
     * 删除数组中数据
     * @param {array} records   待删除数据
     * @param {array} targetRecords   目标数据
     * @param {string} compareProperty  对比的重复属性
     * @return {array} 删除待删除数据后的目标数据
     */
    filterDelete(records = [], targetRecords = [], compareProperty) {
      const o = new Set();
      records.forEach((record) => {
        o.add(record[compareProperty]);
      });

      return targetRecords.filter((item) => !o.has(item[compareProperty]));
    },
    changeCurrentSize(val) {
      this.currentPage = val;
      this.getNumberList();
    },
    changePageSize(val) {
      this.pageSize = val;
      this.getNumberList();
    },

    retSuper() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.content-all {
  width: 100%;
  text-align: left;
  .transfer {
    width: 1200px;
    margin: 20px auto;
    .col-l {
      border: 1px solid #000;
      padding: 0 1px;
      
    }

    .title {
      margin: 5px 0;
      text-align: left;
      height: 30px;
    }
    .tap-btn {
      width: 36px;
      height: 36px;
      margin: 10px auto;
      color: #f8f8f8;
      padding: 0;
      font-size: 25px;
      background: #55c4b8;
       float: left;
    }
    .row-wigth {
      width: 560px;
      height: 560px;
      // background: yellowgreen;
      float: left;
      padding: 5px 0;
      position: relative;
    }
    .el-table {
      width: 550px;
      margin: 20px 0;
      font-size: 12px;
    }
    .el-table-column {
      padding: 6px 10px;
    }
    .sacheripu {
      width: 364px;
      height: 30px;
      margin-left: 60px;
    }
    .search {
      width: 30px;
      height: 30px;
      font-size: 24px;
      margin: 8px 90px 0 0;
      display: block;
      float: right;
    }
    .col {
      width: 36px;
      height: 151px;
      margin: 200px 20px 0 20px;
    }
  }
  select {
    width: 494px;
    height: 30px;
  }
  .page {
    width: 558px;
    height: 30px;
    position: absolute;
    bottom: -50px;
    // left: 190px;
    
    display: flex;
    .el-pagination{
      // text-align: center;
      margin: 0 auto;
    }
    span {
      font-size: 12px;
      line-height: 28px;
    }
  }
}
.font-color{
  color: red;
  margin-top:4px;
}
.bottom-btn{
  width: 600px;
  margin: 0 auto;
  // position: absolute;
  bottom: 100px;
  overflow: hidden;
}
.el-row {
  text-align: center;
  height: 40px;
  margin: 200px auto;
 
}

.btnret:hover {
  background: #55c4b8;
  color: #f8f8f8;
}
.el-button:hover {
  background: #55c4b8;
  border: 1px solid #55c4b8;
  color: #f8f8f8;
}
.el-button {
  width: 200px;
  height: 40px;
  border: 1px solid #55c4b8;
  color: #55c4b8;
}

.btnSty {
  background: #55c4b8;
  color: #fff;
}
.btnSty:hover {
  background: #55c4b8;
  color: #fff;
  border: 1px solid #55c4b8;
}
.select {
  border-radius: 3px;
  &.blink {
    border-color: #ff0000; /* 原始颜色 */
    animation: blink3Times 0.6s ease-in-out 3; /* 0.5秒为一个闪烁周期，共执行3次 */
  }
}
/* 定义闪烁动画 */
@keyframes blink3Times {
  0%, 100% {
    border-color: #ff0000; /* 原始颜色 */
    box-shadow: none;
  }
  50% {
    border-color: #ff0000; /* 闪烁时的颜色 */
    box-shadow: 0 0 3px #ff0000; /* 可选：添加发光效果增强闪烁感 */
  }
}
</style>
